import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { useLang } from "../../contexts/LanguageContext";
import { api } from "../../lib/api";

const FIELDS = [
  { key: "site_title_tr", label: "Site Title (TR)" },
  { key: "site_title_en", label: "Site Title (EN)" },
  { key: "tagline_tr", label: "Tagline (TR)" },
  { key: "tagline_en", label: "Tagline (EN)" },
  { key: "contact_email", label: "Contact Email" },
  { key: "contact_phone", label: "Contact Phone" },
  { key: "address_tr", label: "Address (TR)" },
  { key: "address_en", label: "Address (EN)" },
  { key: "whatsapp_number", label: "WhatsApp Number" },
  { key: "instagram", label: "Instagram URL" },
  { key: "linkedin", label: "LinkedIn URL" },
  { key: "twitter", label: "Twitter URL" },
  { key: "youtube", label: "YouTube URL" },
  { key: "tiktok", label: "TikTok URL" },
  { key: "ga_id", label: "Google Analytics ID" },
  { key: "meta_description_tr", label: "Meta Description (TR)" },
  { key: "meta_description_en", label: "Meta Description (EN)" },
  { key: "working_hours_tr", label: "Working Hours (TR)" },
  { key: "working_hours_en", label: "Working Hours (EN)" },
];

const Settings = () => {
  const { t } = useLang();
  const [settings, setSettings] = useState({});
  const [pw, setPw] = useState({ current_password: "", new_password: "" });

  useEffect(() => {
    api.get("/admin/settings").then(({ data }) => setSettings(data)).catch(() => {});
  }, []);

  const save = async () => {
    try {
      await api.put("/admin/settings", { settings });
      toast.success(t.admin.saved);
    } catch (e) { toast.error(e?.response?.data?.detail || "Error"); }
  };

  const changePw = async (e) => {
    e.preventDefault();
    try {
      await api.post("/auth/change-password", pw);
      toast.success(t.admin.saved);
      setPw({ current_password: "", new_password: "" });
    } catch (er) { toast.error(er?.response?.data?.detail || "Error"); }
  };

  return (
    <div data-testid="admin-settings">
      <h1 className="font-display" style={{ fontSize: "2.5rem", fontWeight: 300, color: "var(--warm-off-white)", marginBottom: 24 }}>{t.admin.nav.settings}</h1>

      <div style={{ background: "var(--rich-black-light)", border: "1px solid rgba(139,32,53,0.25)", padding: 32 }}>
        <div className="grid" style={{ gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))", gap: 20 }}>
          {FIELDS.map((f) => (
            <div key={f.key}>
              <label className="font-mono" style={{ fontSize: "0.65rem", letterSpacing: "0.18em", color: "var(--gold)", textTransform: "uppercase" }}>{f.label}</label>
              <input data-testid={`setting-${f.key}`} className="input-line" value={settings[f.key] || ""} onChange={(e) => setSettings({ ...settings, [f.key]: e.target.value })} style={{ marginTop: 8 }} />
            </div>
          ))}
        </div>
        <button data-testid="settings-save" onClick={save} className="font-mono" style={{ marginTop: 32, padding: "12px 28px", background: "var(--gold)", color: "var(--rich-black)", border: "none", fontSize: "0.7rem", letterSpacing: "0.2em", textTransform: "uppercase", cursor: "pointer" }}>{t.admin.save}</button>
      </div>

      <div style={{ marginTop: 40, background: "var(--rich-black-light)", border: "1px solid rgba(139,32,53,0.25)", padding: 32, maxWidth: 480 }}>
        <h2 className="font-display" style={{ fontSize: "1.5rem", color: "var(--warm-off-white)", marginBottom: 24 }}>{t.admin.passwordChange}</h2>
        <form onSubmit={changePw} style={{ display: "flex", flexDirection: "column", gap: 20 }}>
          <div>
            <label className="font-mono" style={{ fontSize: "0.65rem", letterSpacing: "0.18em", color: "var(--gold)", textTransform: "uppercase" }}>{t.admin.currentPw}</label>
            <input data-testid="current-pw" type="password" required value={pw.current_password} onChange={(e) => setPw({ ...pw, current_password: e.target.value })} className="input-line" style={{ marginTop: 8 }} />
          </div>
          <div>
            <label className="font-mono" style={{ fontSize: "0.65rem", letterSpacing: "0.18em", color: "var(--gold)", textTransform: "uppercase" }}>{t.admin.newPw}</label>
            <input data-testid="new-pw" type="password" required value={pw.new_password} onChange={(e) => setPw({ ...pw, new_password: e.target.value })} className="input-line" style={{ marginTop: 8 }} />
          </div>
          <button data-testid="change-pw-submit" type="submit" className="font-mono" style={{ padding: "12px 28px", background: "var(--bordeaux)", color: "var(--warm-off-white)", border: "none", fontSize: "0.7rem", letterSpacing: "0.2em", textTransform: "uppercase", cursor: "pointer", alignSelf: "flex-start" }}>{t.admin.changePw}</button>
        </form>
      </div>
    </div>
  );
};

export default Settings;
